import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);


//store
const geometas = new vapi({
    namespaced : true,
    baseURL: `${process.env.VUE_APP_REST}/api/geometa`,
    state: {
        Ageometas: []
    }
}).get({
    action: "geometasfiltrados",   
    path: function (obj) {
        return `ListFiltros/${obj.idsubregion}/${obj.iddepartamento}/${obj.idmunicipio}/${obj.idperiodo}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Ageometas = payload.data;
    }
}).get({
    action: "geometasbyindicador",   
    path: function (obj) {
        return `ListFiltroindicador/${obj.idindicador}/${obj.idperiodo}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Ageometas = payload.data;
    }
}).delete({
    action: "eliminargeometa",
    path: function (obj) {
        return `${obj.idgeometa}`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "ActualizarGeometa",
    path: function () {
        return `guardargeometa`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "InsertarGeometa",
    path: function () {
        return `insertargeometa`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
})

.getStore();

geometas.getters = {
    ggeometasfiltradas: state => {
        return state.Ageometas;
    }
}

export default geometas;